import * as XLSX from "xlsx";

const texto = (c) => String(c === null || c === undefined ? "" : c).trim();

// Reporte "Costos por servicio de almacenamiento" de MeLi, hoja Detalle. Cada producto ocupa 2 filas:
// la primera trae el costo por dia y la segunda las unidades (sin Codigo ML, no se usa).
// Regresa null si el archivo no es ese reporte.
export function almacenamientoMeli(workbook) {
  const hoja = workbook.Sheets["Detalle"];
  if (!hoja) return null;
  const hojaFilas = XLSX.utils.sheet_to_json(hoja, { header: 1, defval: "" });
  const iHead = hojaFilas.findIndex(
    (f) => f.some((c) => texto(c) === "SKU") && f.some((c) => /^Costos acumulados/i.test(texto(c)))
  );
  if (iHead < 0) return null;

  const head = hojaFilas[iHead].map(texto);
  const colCodigoML = head.indexOf("Código ML");
  const colSKU = head.indexOf("SKU");
  const colProducto = head.indexOf("Producto");
  const colTotal = head.findIndex((c) => /^Costos acumulados/i.test(c));
  const dias = [];
  head.forEach((c, i) => {
    const m = c.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (m) dias.push({ i, fecha: `${m[3]}-${m[2]}-${m[1]}` });
  });
  if (colCodigoML < 0 || !dias.length) return null;

  const filas = hojaFilas
    .slice(iHead + 1)
    .filter((f) => texto(f[colCodigoML]))
    .map((f) => ({
      sku: texto(f[colSKU]) || `Sin SKU (${texto(f[colCodigoML])})`,
      producto: texto(f[colProducto]),
      total: Number(f[colTotal]) || 0,
      dias: dias.map((d) => ({ fecha: d.fecha, total: Number(f[d.i]) || 0 })).filter((d) => d.total > 0),
    }));

  return { inicio: dias[0].fecha, fin: dias[dias.length - 1].fecha, filas };
}
